export default __webpack_public_path__ + "static/media/default_avatar.42666429.svg";